export default {"src":"/_next/static/media/epcc logo.242b9954.svg","height":66,"width":259,"blurWidth":0,"blurHeight":0};